import styled from 'styled-components';

export const ApprovalList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 0 0 auto;
`;
